<template>
  <div class="sub-footer">
    <TextureHome
      v-if="$route.path == '/'"
      class="sub-footer__texture"
    />
    <TextureForward
      v-if="$route.path == '/the-path-forward'"
      class="sub-footer__texture"
    />
    <TextureTrends
      v-if="$route.path == '/market-trends'"
      class="sub-footer__texture"
    />
    <TextureAbout
      v-if="$route.path == '/about'"
      class="sub-footer__texture"
    />
    <TextureFinancials
      v-if="$route.path == '/financials'"
      class="sub-footer__texture"
    />
    <TextureLeadership
      v-if="$route.path == '/leadership'"
      class="sub-footer__texture"
    />
    <template v-if="$route.path == '/about'">
      <div class="sub-footer__actions sub-footer__actions--about">
        <div
          class="sub-footer__action"
          data-aos="fade-right"
          data-aos-duration="400"
          data-aos-offset="0"
        >
          <Button to="/">
            Annual Report Home
          </Button>
        </div>
        <div
          class="sub-footer__action"
          data-aos="fade-left"
          data-aos-duration="400"
          data-aos-offset="0"
        >
          <Button to="https://www.svmic.com">
            Visit svmic.com
          </Button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="sub-footer__actions">
        <div
          class="sub-footer__action"
          data-aos="fade-up"
          data-aos-duration="400"
          data-aos-offset="0"
        >
          <Button
            :to="nextRoute"
            arrow="right"
          >
            Next Section
          </Button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Button from '@/components/control/Button';
import TextureHome from '@/assets/texture-subfooter-home.svg';
import TextureForward from '@/assets/texture-subfooter-forward.svg';
import TextureTrends from '@/assets/texture-subfooter-trends.svg';
import TextureFinancials from '@/assets/texture-subfooter-financials.svg';
import TextureLeadership from '@/assets/texture-subfooter-leadership.svg';
import TextureAbout from '@/assets/texture-subfooter-about.svg';

export default {
  name: 'TheSubFooter',
  components: {
    Button,
    TextureHome,
    TextureForward,
    TextureTrends,
    TextureFinancials,
    TextureLeadership,
    TextureAbout,
  },
  props: {
    nextRoute: String
  }
};
</script>
